var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('section',{staticClass:"steps"},[_c('ul',_vm._l((_vm.stepping.steps),function(step){return _c('nav-steps-links',{key:step.order,attrs:{"step":step,"current-step":_vm.stepping.currentStep}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }